<template>
  <!-- banner-->
  <div class="">
    <!--删除列表时使用的是rowKey的id-->
    <x-tabula
      ref="table"
      rowKey="bannerId"
      :dataSource="dataSource"
      :searchList="searchList"
      :columns="columns"
      :tableOptList="tableOptList"
      :rowOptList="rowOptList"
      :searchParams.sync="searchParams"
      :listApi="listApi"

      :deleteParam="deleteParam"
      :rowSelection="false"
    >
      <template slot="opt_Image" slot-scope="{row}">
        <img style="height: 44px" :src="row.image" alt="" @click="showbigimg(row.faceUrl,'人脸照片')">
      </template>
      <template slot="opt_t" slot-scope="{row}">
        <a-switch v-hasPermi="['community:localBanner:editStatus']" @change="changeStatus(row)" :checked="Number(row.status) ? true : false"/>
      </template>
      <template slot="opt_status" slot-scope="{row}">
        <div style="display: flex; align-items: center">
          <span class="circle-dot" :class="statusColor[row.status] + '-bg'"></span>
          <span>{{ statusObj[row.status] }}</span>
        </div>
      </template>
    </x-tabula>

    <!-- <big-img ref='bigImg'></big-img> -->
    <add ref='model' @updateTable = 'updateTable'></add>
  </div>
</template>

<script>
// import bigImg from '@/components/bigImg.vue';
import add from './add.vue';
export default {
  name: 'banner',
  components: {
    add
  },
  data () {
    return {
      visible: false,
      rowData: {},
      searchList: [
        {
          inputType: 'input',
          options: [],
          handle: '',
          placeholder: '名称',
          props: ['name']
        }, {
          inputType: 'select',
          options: [
            { value: '1', label: '启用' },
            { value: '0', label: '禁用' }
          ],
          handle: '',
          placeholder: '状态',
          props: ['status']
        }
      ],
      tableOptList: [
        {
          text: '新增',
          icon: 'plus',
          permi: ['community:localBanner:add'],
          handle: () => { this.$refs.model.show(); }
        }
      ],
      rowOptList: [
        {
          text: '编辑',
          handle: row => { this.$refs.model.show(row.bannerId); },
          permi: ['community:localBanner:edit']
        },
        {
          text: '删除',
          handle: row => this.$refs.table.showDeleteConfirm(row),
          rowOptDisHandle: row => false, // 禁用按钮
          permi: ['community:localBanner:remove']
        }
      ],
      columns: [
        {
          title: '范围',
          dataIndex: 'area',
          align: '',
          width: ''
        },
        {
          title: 'BANNER图片',
          dataIndex: '',
          align: '',
          width: '',
          scopedSlots: { customRender: 'Image' }
        }, {
          title: '广告位',
          dataIndex: 'scopeTypeDesc',
          align: '',
          width: '200'
        }, {
          title: '名称',
          dataIndex: 'name',
          align: '',
          width: ''
        }, {
          title: '有效时间',
          dataIndex: 'expireDesc',
          align: '',
          width: ''
        },
        {
          title: '排序',
          dataIndex: 'sort',
          align: '',
          width: ''
        },
        {title: '状态', dataIndex: '', align: '', width: '80px', scopedSlots: {customRender: 't'}},
        {title: '状态', dataIndex: 'status', align: '', width: '80px', scopedSlots: {customRender: 'status'}},
        {
          title: '操作',
          dataIndex: 'action',
          align: '',
          width: '100px',
          scopedSlots: { customRender: 'action' }
        }
      ],
      statusObj: ['禁用', '启用'],
      statusColor: ['info', 'success'],
      dataSource: [],
      searchParams: {
        name: undefined,
        status: undefined
      },
      listApi: {
        url: '/local/banner/list',
        resHandle: '', // this.resHandle
        searchHandle: '' // searchHandle
      },
      deleteParam: {
        url: '/local/banner/',
        title: '该Banner图片',
        key: 'name',
        resHandle: '' // 执行完删除的回调方法
      }
    };
  },
  methods: {
    /* 切换状态 */
    changeStatus (row) {
      let status = row.status === 1 ? 0 : 1;
      this.$put({
        url: `/local/banner/changeStatus/${row.bannerId}`,
        params: {
          status: status
        }
      }).then(({data}) => {
        this.$message.success('状态切换成功！');
        this.$refs.table.getTableList();
      });
    },
    updateTable (res) {
      if (res && res.code == 200) {
        this.$message.success(res.msg);
      }
      this.$refs.table.getTableList();
    },
    showbigimg (img, title) {
      this.$refs.bigImg.show(img, title);
    },
    /** 弹窗详情 */
    modalDetail (row) {
      this.visible = true;
      this.rowData = row;
    },
    resHandle (res) {
      return res;
    },
    searchHandle (selectData) {
      return selectData;
    }
  }
};
</script>

<style lang="scss" scoped>
</style>
